import { has } from 'lodash';
import { connect } from 'react-redux';
import { removeDetailViewCard } from '../../../actions';
import {
  ACL_RESOURCE_TYPE_DF_DATASET,
  ACL_RESOURCE_TYPE_DF_SOURCE,
} from '../../../constants/aclConstants';
import { getResourceEntity } from '../../../lib/PipelineUtils';
import { getConnectionOrVendorType } from '../../../lib/ResourceUtils';
import FlowDetailView from './FlowDetailView';

/**
 * FlowDetailViewContainer - Redux container for FlowDetailView
 *
 * Props passed through to FlowDetailView:
 * @param {boolean} [insightsOnly] - Legacy prop for backward compatibility.
 *                                   If true, shows only insights tab.
 * @param {Function} [toggleCloneFlowModal] - Callback for clone flow modal.
 *
 * Note: Redux connect automatically passes through props not in mapStateToProps.
 */

const mapStateToProps = (state) => {
  const {
    entities,
    app: {
      listing: { aclQueryMode },
    },
    pipelines: {
      detailView: { nodeKey, preSelectedTab, id, type },
    },
    paging: { metaInfoById },
  } = state;

  const { flowNodes, vendors } = entities;

  // When viewing a flow, nodeKey is the origin_node_id (root source node ID)
  // flowNodes[nodeKey] is the root SOURCE node, not the flow itself
  // We need to get the flow data by finding the pipeline that has this origin_node_id
  const flowNode = flowNodes[nodeKey];

  if (!flowNode) {
    return {};
  }

  // Get the flow data by merging the root source node with its source entity
  // This gives us the flow representation (source node + source entity = flow)
  const data = getResourceEntity(flowNode, entities, true, ['name', 'description']);

  if (!data) {
    return {};
  }

  let aclResourceType;
  let connectionOrVendorType;

  if (data.type === 'SOURCE') {
    aclResourceType = ACL_RESOURCE_TYPE_DF_SOURCE;
    connectionOrVendorType = getConnectionOrVendorType(data, vendors, 'source_type', 'vendor_id');
  } else {
    aclResourceType = ACL_RESOURCE_TYPE_DF_DATASET;
  }

  let connectionInfo = null;

  if (connectionOrVendorType && metaInfoById && has(metaInfoById, connectionOrVendorType)) {
    connectionInfo = metaInfoById[connectionOrVendorType];
  }

  return {
    aclQueryMode,
    data,
    connectionInfo,
    aclResourceType,
    preSelectedTab,
  };
};

export default connect(mapStateToProps, {
  removeDetailViewCard,
})(FlowDetailView);
